export const servicesCTAData = {
  badge: "LIMITED SPOTS AVAILABLE",
  headline: "Ready to Scale Your Clinic?",
  subheadline: "Book a Free Growth Audit & Get a Custom Strategy",
  description:
    "We'll analyze your current marketing, identify what's holding you back, and show you exactly how to fill your calendar with high-quality patients guaranteed.",
  stats: [
    { number: "25+", label: "Avarge Monthly Booking" },
    { number: "5M+", label: "Revenue Generated" },
    { number: "3-5X", label: "ROI in 90 Days" },
  ],
  benefits: [
    "Complete marketing audit (worth £2,500)",
    "Custom growth roadmap for your clinic",
    "Competitor analysis & positioning strategy",
    "Zero obligation just actionable insights",
  ],
  ctaButton: {
    text: "Claim Your Free Audit",
    link: "/contact",
  },
  urgency: "Only 3 strategy calls available this month",
  testimonial: {
    quote:
      "We went from 12 bookings/month to 47 in just 90 days. The ROI was insane.",
    author: "Sophie Shotter",
    clinic: "Velvet Veil Aesthetics",
    image:
      "https://images.unsplash.com/photo-1594824476967-48c8b964273f?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  visualImage:
    "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // Team meeting/strategy
};
